import React, { Fragment, useEffect, useState } from 'react';
import coinIcon from "../../images/feed_images/coin-icon.svg"
import ThemeButton from 'components/NewHome/ThemeButton';
import { useNavigate } from 'react-router-dom';
import { getUserCoin } from 'api/coinApi';

function Coins() {
    const loginUser = localStorage.getItem('name')
    const navigate = useNavigate();
    const [coin, setCoin] = useState<number>(0)

    const goToCoinPackages = () => {
        navigate('/buy-coin');
    };

    const getLoginUserCoinCount = async () => {
        const coinCount = await getUserCoin()
        setCoin(coinCount as number)
    }
    useEffect(() => {
        getLoginUserCoinCount()
    }, [])

    return (
        <Fragment>
            <div className='flex gap-4 items-center justify-center md:justify-end md:mt-[unset] mt-5'>
                <div className='p-3 text-base bg-[#FBE8A6] rounded-full w-32 text-center font-medium'>
                    {loginUser} - {coin}
                </div>
                <ThemeButton
                    bgColor="bg-primaryColor"
                    textColor="text-white"
                    padding="px-3 py-2"
                    size="text-base"
                    rounded="rounded-full"
                    className="w-[135px] font-medium flex items-center justify-between"
                    onClick={goToCoinPackages}
                >
                    Buy coin <img className='w-[30px] h-[30px]' src={coinIcon} alt={coinIcon} />
                </ThemeButton>
            </div>
        </Fragment>
    )
}
export default Coins;